/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/

import { StorageWrapperFactory } from "../../server";

export class ClientStorageWrapperFactory extends StorageWrapperFactory {}
